import {
  useAutomationResourceActions,
  useAutomationResources
} from "../hooks/useAutomationResources";
import { ResourceCollection } from "../../system/resources/ResourceCollection";
import { Resources } from "../../system/resources/useResources";

export const AutomationResources = ({ automationId }: { automationId: string }) => {
  const { resources } = useAutomationResources(automationId);
  const { addResource, removeResource } = useAutomationResourceActions();

  return (
    <ResourceCollection
      resources={resources}
      title={
        resources && resources?.length > 0
          ? "Resources linked to this automation"
          : "No resources in this automation"
      }
      onAdd={r => addResource(automationId, Resources.identifier(r))}
      onRemove={r => removeResource(automationId, Resources.identifier(r))}
    />
  );
};
